var _defs, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLanding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2808.41 796.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#eee;}.cls-2{fill:#fff;}.cls-3{fill:#dadada;}.cls-4{fill:#aeaeae;}.cls-5{fill:#f4d4b5;}.cls-6{fill:#9e9e9e;}.cls-7{fill:#e0e0e0;}.cls-8{fill:#ebebeb;}.cls-9{fill:#ff8e82;}.cls-10{fill:#b9b9b9;}.cls-11{fill:#494949;}.cls-12{fill:none;}.cls-13{fill:#4c4c4c;stroke:#494949;stroke-miterlimit:10;stroke-width:4px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M959.68,501.81H935V432.42h4.69v-7.1H935V387.78c0-10.8-15.15-10.94-15.15.07L820.1,345.2,717.63,388v-.7c0-4.54-3.39-8.22-7.57-8.22s-7.58,3.68-7.58,8.22v38h-5v7.1h5V796.51l56.14,0H959.68Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2277.7,
    y: 602.29,
    width: 17.37,
    height: 18.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2282.03,
    y: 346.55,
    width: 193.06,
    height: 441.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2324.29,
    y: 323.28,
    width: 108.54,
    height: 65.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 2234.39,
    y: 272.75,
    width: 11.9,
    height: 3.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 2131.61,
    y: 272.75,
    width: 90.46,
    height: 3.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 794.08,
    y: 246.22,
    width: 11.3,
    height: 3.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 696.5,
    y: 246.22,
    width: 85.89,
    height: 3.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 2192.39,
    y: 253.97,
    width: 91.3,
    height: 3.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 966.31,
    y: 285.71,
    width: 14.37,
    height: 3.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2020.7,173.22l-1.57-3.19q-.11-.19-.24-.51a17.72,17.72,0,0,0-10.77-10l1.09-3.7a21.14,21.14,0,0,1,11.47,9.23,21.61,21.61,0,0,1,11.52-9.23l1.09,3.7a17.77,17.77,0,0,0-9.61,7.66Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M694.49,213.55l-1.57-3.19c-.07-.13-.14-.29-.23-.48a16.57,16.57,0,0,0-10.08-9.34l1.09-3.7a19.94,19.94,0,0,1,10.77,8.59,20.22,20.22,0,0,1,10.82-8.59l1.09,3.7a16.71,16.71,0,0,0-9,7.17Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1038.6,372.39,1037,369.2c-.08-.15-.16-.34-.27-.56a19.69,19.69,0,0,0-12-11.1l1.09-3.7a23.17,23.17,0,0,1,12.72,10.37,23.48,23.48,0,0,1,12.75-10.37l1.09,3.7a19.48,19.48,0,0,0-10.71,8.55Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2263.93,171.33h-48.54v-1.94c0-14.51,10.89-26.32,24.27-26.32s24.27,11.81,24.27,26.32Zm-44.88-3.88h41.23c-.92-11.47-9.81-20.5-20.62-20.5S2220,156,2219.05,167.45Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M398.44,164.27H222l-.26-1.59a44.12,44.12,0,0,1-.62-7.29c0-22.3,16.73-40.44,37.3-40.44a31.72,31.72,0,0,1,3.35.17c3.72-24.57,23.44-42.86,46.58-42.86,20.2,0,38.37,14.26,44.77,34.9a37.87,37.87,0,0,1,8.2-.9c14.53,0,27.94,8.27,35.4,21.71a30.65,30.65,0,0,1,13.61-3.21,31.09,31.09,0,0,1,21.93,9.14c6.8-11.75,18.7-19,31.6-19,15.71,0,29.83,10.77,35.12,26.81l-3.37,1.31c-4.78-14.5-17.55-24.24-31.75-24.24-12.37,0-23.72,7.33-29.64,19.11l-1.17,2.34-1.69-1.92a27.93,27.93,0,0,0-21-9.72,27.07,27.07,0,0,0-13.5,3.59l-1.56.88-.84-1.67c-6.63-13.13-19.32-21.29-33.11-21.29a34.79,34.79,0,0,0-9,1.18l-1.66.44-.48-1.78c-5.45-19.93-22.66-33.85-41.84-33.85-21.93,0-40.54,17.78-43.28,41.36l-.22,2-1.8-.27a32.11,32.11,0,0,0-4.63-.35c-18.59,0-33.72,16.4-33.72,36.56a40.33,40.33,0,0,0,.32,5h173.4Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2176.73,277.46h-184v-1.95c0-21.12,15.8-38.26,35.23-38.26a33.55,33.55,0,0,1,20.74,7.32c7.58-11.57,19.73-18.41,32.88-18.41,15.1,0,28.85,9.13,35.77,23.51a33.82,33.82,0,0,1,26-12.42c19.43,0,35.23,17.14,35.23,38.21v1.94Zm-180.42-3.89h178.58c-.89-18-14.72-32.44-31.6-32.44-9.83,0-18.94,4.84-25,13.28l-1.86,2.58-1.2-3c-5.85-14.55-19.08-24-33.71-24-12.58,0-24.15,6.87-31,18.38l-1.09,1.84-1.55-1.38a30.2,30.2,0,0,0-20-7.75C2011,241.13,1997.21,255.52,1996.31,273.57Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2494.22,256.18H2393.81v-1.94c0-20.14,15.11-36.53,33.69-36.53,11.05,0,21.19,5.76,27.52,15.52a23.11,23.11,0,0,1,14.8-5.46c13.45,0,24.4,11.88,24.4,26.47Zm-96.77-3.88h93.11c-.91-11.55-9.87-20.64-20.74-20.64a19.88,19.88,0,0,0-14,5.89l-1.6,1.58-1.13-2c-5.54-9.73-15.11-15.54-25.6-15.54C2411.5,221.6,2398.38,235.2,2397.45,252.3Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M436.6,317.3v-1.94c0-20.06,14.75-36.37,32.88-36.37a31.21,31.21,0,0,1,21.27,8.5,34.56,34.56,0,0,1,25-11.07c11.82,0,22.65,6.18,29.38,16.64A24.57,24.57,0,0,1,561,287.17c14.31,0,25.95,12.62,25.95,28.14v1.94Zm32.88-34.43c-15.29,0-28.3,13.8-29.24,30.55l143-.05c-.91-12.47-10.56-22.31-22.29-22.31a21.34,21.34,0,0,0-15,6.33l-1.6,1.57-1.13-2c-5.94-10.44-16.21-16.67-27.46-16.67a30.89,30.89,0,0,0-23.62,11.2l-1.23,1.44-1.31-1.35A28,28,0,0,0,469.48,282.87Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M434.92,97.52l-1.78-2.69c9.8-7.58,15.54-19.4,15.77-32.43.39-22.48-16.16-41.11-36.89-41.53h-.72c-20.4,0-37.19,17.79-37.58,40a43.55,43.55,0,0,0,4.66,20.44l-2.67,1.6a47.11,47.11,0,0,1-5-22.11c.42-24,18.57-43.25,40.63-43.25h.78c22.41.46,40.29,20.6,39.87,44.9C451.71,76.34,445.34,89.44,434.92,97.52Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2403.48 373.81 2403.48 409.77 2403.48 417.12 2403.48 477.98 2413.68 477.98 2413.68 417.12 2413.68 409.77 2413.68 373.81 2403.48 373.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2377.23 373.81 2377.23 409.77 2377.23 417.12 2377.23 477.98 2387.42 477.98 2387.42 417.12 2387.42 409.77 2387.42 373.81 2377.23 373.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2350.97 373.81 2350.97 409.77 2350.97 417.12 2350.97 477.98 2361.17 477.98 2361.17 417.12 2361.17 409.77 2361.17 373.81 2350.97 373.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "850.44 409.16 850.44 432.36 850.44 437.1 850.44 476.38 860.63 476.38 860.63 437.1 860.63 432.36 860.63 409.16 850.44 409.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "824.18 409.16 824.18 445.12 824.18 452.47 824.18 513.33 834.38 513.33 834.38 452.47 834.38 445.12 834.38 409.16 824.18 409.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "797.93 409.16 797.93 445.12 797.93 452.47 797.93 513.33 808.12 513.33 808.12 452.47 808.12 445.12 808.12 409.16 797.93 409.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "771.67 409.16 771.67 432.36 771.67 437.1 771.67 476.38 781.87 476.38 781.87 437.1 781.87 432.36 781.87 409.16 771.67 409.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "465.39 563.09 465.39 415.6 492.63 415.6 492.63 387.06 657.37 387.06 657.37 566.06 465.39 563.09"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 614.24,
    y: 439.54,
    width: 106.75,
    height: 88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M185.49,378.71v-1.94c0-20.06,14.75-36.38,32.89-36.38a31.24,31.24,0,0,1,21.27,8.51,34.56,34.56,0,0,1,25-11.07c11.81,0,22.64,6.18,29.37,16.64a24.59,24.59,0,0,1,15.84-5.89c14.31,0,25.95,12.62,25.95,28.14v1.94Zm32.89-34.43c-15.3,0-28.31,13.8-29.25,30.55l143-.05c-.92-12.47-10.57-22.31-22.3-22.31a21.3,21.3,0,0,0-15,6.33l-1.6,1.57-1.13-2c-5.95-10.44-16.21-16.67-27.46-16.67A30.86,30.86,0,0,0,241,352.91l-1.23,1.44L238.5,353A28,28,0,0,0,218.38,344.28Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 2599.35,
    y: 104.03,
    width: 79.44,
    height: 3.63
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2684.76,108h-100v-1.82c0-20,15-36.34,33.51-36.34,11,0,21.17,5.77,27.45,15.55a23,23,0,0,1,14.8-5.5c13.38,0,24.25,11.79,24.25,26.29Zm-96.62-3.63h93.21c-.86-11.65-9.87-20.85-20.84-20.85a20,20,0,0,0-14,5.91L2645,90.89,2643.92,89c-5.55-9.75-15.14-15.57-25.66-15.57C2602.19,73.46,2589,87.16,2588.14,104.36Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2721.07,291.59h-48.54v-1.94c0-14.52,10.89-26.33,24.27-26.33s24.27,11.81,24.27,26.33Zm-44.88-3.89h41.22c-.91-11.46-9.8-20.49-20.61-20.49S2677.1,276.24,2676.19,287.7Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2580,322.69l-1.58-3.19-.26-.56a19.75,19.75,0,0,0-12-11.1l1.08-3.7A23.13,23.13,0,0,1,2580,314.51a23.48,23.48,0,0,1,12.75-10.37l1.09,3.7a19.53,19.53,0,0,0-10.71,8.55Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2537.64,156.29h-69V155c0-13.85,10.39-25.11,23.15-25.11a22.51,22.51,0,0,1,18.92,10.67,15.87,15.87,0,0,1,10.18-3.76c9.25,0,16.77,8.17,16.77,18.2Zm-66.52-2.67h64c-.63-7.93-6.79-14.18-14.26-14.18a13.64,13.64,0,0,0-9.62,4.05l-1.1,1.08-.78-1.37c-3.81-6.69-10.38-10.68-17.6-10.68C2480.78,132.52,2471.76,141.87,2471.12,153.62Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 956.57,
    y: 558.73,
    width: 126.11,
    height: 220.26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1078.26,
    y: 388.88,
    width: 193.06,
    height: 389.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1101.01 404.01 1101.01 422.04 1101.01 425.73 1101.01 456.25 1135.31 456.25 1135.31 425.73 1135.31 422.04 1135.31 404.01 1101.01 404.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1160.54 404.01 1160.54 422.04 1160.54 425.73 1160.54 456.25 1194.84 456.25 1194.84 425.73 1194.84 422.04 1194.84 404.01 1160.54 404.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1219.78 404.01 1219.78 422.04 1219.78 425.73 1219.78 456.25 1254.08 456.25 1254.08 425.73 1254.08 422.04 1254.08 404.01 1219.78 404.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1101.16 481 1101.16 499.04 1101.16 502.73 1101.16 533.25 1135.46 533.25 1135.46 502.73 1135.46 499.04 1135.46 481 1101.16 481"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1160.69 481 1160.69 499.04 1160.69 502.73 1160.69 533.25 1194.99 533.25 1194.99 502.73 1194.99 499.04 1194.99 481 1160.69 481"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1219.93 481 1219.93 499.04 1219.93 502.73 1219.93 533.25 1254.23 533.25 1254.23 502.73 1254.23 499.04 1254.23 481 1219.93 481"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1271.32,
    y: 498.79,
    width: 193.06,
    height: 280.52
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1293.92 535.52 1293.92 547.85 1293.92 550.37 1293.92 571.24 1328.22 571.24 1328.22 550.37 1328.22 547.85 1328.22 535.52 1293.92 535.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1353.46 535.52 1353.46 547.85 1353.46 550.37 1353.46 571.24 1387.76 571.24 1387.76 550.37 1387.76 547.85 1387.76 535.52 1353.46 535.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1412.69 535.52 1412.69 547.85 1412.69 550.37 1412.69 571.24 1446.99 571.24 1446.99 550.37 1446.99 547.85 1446.99 535.52 1412.69 535.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1294.07 588.16 1294.07 600.49 1294.07 603.01 1294.07 623.88 1328.38 623.88 1328.38 603.01 1328.38 600.49 1328.38 588.16 1294.07 588.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1353.61 588.16 1353.61 600.49 1353.61 603.01 1353.61 623.88 1387.91 623.88 1387.91 603.01 1387.91 600.49 1387.91 588.16 1353.61 588.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1412.84 588.16 1412.84 600.49 1412.84 603.01 1412.84 623.88 1447.14 623.88 1447.14 603.01 1447.14 600.49 1447.14 588.16 1412.84 588.16"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1464.38,
    y: 382.56,
    width: 193.06,
    height: 397.12
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1585.84 367.45 1585.84 403.41 1585.84 410.76 1585.84 471.62 1596.04 471.62 1596.04 410.76 1596.04 403.41 1596.04 367.45 1585.84 367.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1559.59 367.45 1559.59 403.41 1559.59 410.76 1559.59 471.62 1569.78 471.62 1569.78 410.76 1569.78 403.41 1569.78 367.45 1559.59 367.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1533.33 367.45 1533.33 403.41 1533.33 410.76 1533.33 471.62 1543.53 471.62 1543.53 410.76 1543.53 403.41 1543.53 367.45 1533.33 367.45"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1506.65,
    y: 354.84,
    width: 108.54,
    height: 59.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1657.45,
    y: 544.65,
    width: 126.11,
    height: 236.86
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1736.21 573.21 1736.21 596.41 1736.21 601.16 1736.21 640.43 1746.41 640.43 1746.41 601.16 1746.41 596.41 1746.41 573.21 1736.21 573.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1709.96 573.21 1709.96 609.17 1709.96 616.52 1709.96 677.38 1720.15 677.38 1720.15 616.52 1720.15 609.17 1720.15 573.21 1709.96 573.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1683.7 573.21 1683.7 609.17 1683.7 616.52 1683.7 677.38 1693.9 677.38 1693.9 616.52 1693.9 609.17 1693.9 573.21 1683.7 573.21"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1657.45,
    y1: 601.16,
    x2: 1657.45,
    y2: 640.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2069.06,526.48h-27.67V461.93h5.26v-6.61h-5.26V420.4c0-10-17-10.17-17,.07l-111.93-39.68-115,39.84V420c0-4.22-3.8-7.64-8.5-7.64s-8.5,3.42-8.5,7.64v35.34h-5.56v6.61h5.56v338.7l63,0h225.57Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1931.9 402.73 1931.9 425.94 1931.9 430.68 1931.9 469.95 1942.1 469.95 1942.1 430.68 1942.1 425.94 1942.1 402.73 1931.9 402.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1879.39 402.73 1879.39 438.69 1879.39 446.04 1879.39 506.9 1889.59 506.9 1889.59 446.04 1889.59 438.69 1889.59 402.73 1879.39 402.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1853.14 402.73 1853.14 425.94 1853.14 430.68 1853.14 469.95 1863.33 469.95 1863.33 430.68 1863.33 425.94 1863.33 402.73 1853.14 402.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1903.79 402.73 1903.79 438.69 1903.79 446.04 1903.79 506.9 1913.98 506.9 1913.98 446.04 1913.98 438.69 1913.98 402.73 1903.79 402.73"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M838,772.19l-6-24.87h1.27l-1.2-25.16-2.49-15.88-.56-.58a5,5,0,0,0,1.48-.22c3.38-1.09,5.09-5.71,3.83-10.32s-5-7.48-8.39-6.4-5.1,5.71-3.84,10.32a10.59,10.59,0,0,0,2.29,4.31l-2.19,5.24-8.33,14.81-1.51,24,3.74.38-.5,10.57.69.77-.19,13.29L803.75,800l2.7,3.72,18.07-27.49L827,771l3.42,3.79,5,33.1h4Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 450.13,
    y: 775.09,
    width: 123.66,
    height: 13.08
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "509.88 525.96 482.71 555.42 493.31 555.42 520.48 525.96 509.88 525.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "487.3 525.96 460.13 555.42 470.73 555.42 497.9 525.96 487.3 525.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "532.47 525.96 505.3 555.42 515.89 555.42 543.06 525.96 532.47 525.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "577.64 525.96 550.48 555.42 561.08 555.42 588.24 525.96 577.64 525.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "600.23 525.96 573.06 555.42 583.66 555.42 610.83 525.96 600.23 525.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "622.82 525.96 595.65 555.42 595.72 555.42 632.83 525.96 622.82 525.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "555.05 525.96 527.88 555.42 538.49 555.42 565.65 525.96 555.05 525.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "597.73 571.8 659.95 522.4 591.57 454.67 431.71 454.67 378.19 503.01 464.83 571.8 597.73 571.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "395.85 573.89 395.85 775.11 498.59 775.11 501.82 775.11 592.9 775.11 592.9 573.54 395.85 573.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "253.08 570.75 253.08 775.11 355.82 775.11 359.06 775.11 450.14 775.11 450.14 570.39 253.08 570.75"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 574.15,
    y: 599.61,
    width: 201.23,
    height: 175.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 565.57,
    y: 577.66,
    width: 8.21,
    height: 210.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 253.46,
    y: 572.9,
    width: 326.24,
    height: 8.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 574.43,
    y: 602.33,
    width: 201.2,
    height: 8.72
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "674.76 485.59 555.35 592.76 794.17 592.76 674.76 485.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "351.57 453.58 232.16 563.45 470.98 563.45 351.57 453.58"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 555.93,
    y: 592.78,
    width: 238.82,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 232.16,
    y: 563.08,
    width: 238.08,
    height: 10.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 233.99,
    y: 775.09,
    width: 216.14,
    height: 13.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 573.79,
    y: 775.09,
    width: 224.25,
    height: 13.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 309.22,
    y: 622.37,
    width: 79.93,
    height: 104.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 475.49,
    y: 636.86,
    width: 73.9,
    height: 60.84
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M542.3,661.36v46.93H481.22V661.36Zm6.41-7h-73.9v60.84h73.9V654.41Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 651.33,
    y: 700.7,
    width: 46.61,
    height: 73.26
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "737.8 671.64 717.05 647.58 633.64 647.53 612.76 671.55 612.76 680.82 737.8 680.82 737.8 671.64"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 450.72,
    y: 577.26,
    width: 8.71,
    height: 210.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 619.29,
    y: 681.54,
    width: 7.16,
    height: 93.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 723.6,
    y: 681.54,
    width: 7.16,
    height: 93.88
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "470.48 563.76 392.1 490.38 399.32 481.32 486.65 563.09 470.48 563.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "647.38 510.83 591.65 563.45 575.22 563.09 640.13 501.8 647.38 510.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "578.6 574.24 472.09 574.24 472.09 563.45 588.42 563.09 578.6 574.24"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 612.76,
    y: 672.75,
    width: 126.35,
    height: 8.07
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "450.13 788.17 334.58 788.17 347.57 775.45 450.13 775.45 450.13 788.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "309.68 685.73 367.95 622.54 358.95 622.54 309.68 675.97 309.68 685.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "309.68 715.9 309.68 725.65 388.86 639.79 388.86 630.04 309.68 715.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "327.83 726.75 388.86 660.57 388.86 650.82 318.83 726.75 327.83 726.75"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 309.22,
    y: 622.37,
    width: 8.62,
    height: 105.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 380.54,
    y: 622.37,
    width: 8.62,
    height: 105.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 309.22,
    y: 623.53,
    width: 79.93,
    height: 7.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 309.22,
    y: 719.4,
    width: 79.93,
    height: 7.89
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "650.73 701.19 650.73 704.8 654.05 701.19 650.73 701.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "664.07 773.45 698.32 736.3 698.32 726.55 655.07 773.45 664.07 773.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "683.23 773.45 698.32 757.08 698.32 747.33 674.24 773.45 683.23 773.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "698.32 773.45 698.32 768.1 693.39 773.45 698.32 773.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "650.73 746.35 692.38 701.19 683.38 701.19 650.73 736.6 650.73 746.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "650.73 757.38 650.73 767.13 698.32 715.52 698.32 705.77 650.73 757.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "650.73 725.58 673.22 701.19 664.22 701.19 650.73 715.82 650.73 725.58"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 651.33,
    y: 700.7,
    width: 48.13,
    height: 6.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 652.4,
    y: 700.7,
    width: 4.57,
    height: 73.26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 693.81,
    y: 700.7,
    width: 4.57,
    height: 73.26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 434.09,
    y: 726.83,
    width: 14.87,
    height: 10.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 748.09,
    y: 707.82,
    width: 14.87,
    height: 10.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 756.48,
    y: 638.36,
    width: 19.54,
    height: 10.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 415.69,
    y: 707.82,
    width: 21.84,
    height: 10.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 254.13,
    y: 622.8,
    width: 14.87,
    height: 10.33,
    transform: "translate(526.29 1237.34) rotate(179.77)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 265.63,
    y: 641.75,
    width: 21.84,
    height: 10.33,
    transform: "translate(556.34 1275.17) rotate(179.77)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2269.82,
    y: 771.73,
    width: 278.77,
    height: 19.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2317.11,
    y: 622.89,
    width: 117.16,
    height: 148.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2314.23 776 2056.08 776 2056.08 507.6 2185.08 423.5 2314.23 509.1 2314.23 776"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2338.37 503.38 2185.67 402.26 2032.43 503.14 2038.39 511.9 2185.89 415.81 2332.62 511.9 2338.37 503.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2691.2 771.92 2433.4 771.92 2433.4 497.07 2562.23 410.94 2691.2 498.6 2691.2 771.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2715.19 511.69 2562.49 402.26 2409.25 503.14 2415.21 511.9 2562.7 415.81 2709.44 520.22 2715.19 511.69"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2045.08,
    y: 771.73,
    width: 278.77,
    height: 19.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2423.33,
    y: 771.73,
    width: 278.77,
    height: 19.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 2315.19,
    y: 607.84,
    width: 117.78,
    height: 15.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 2325.25,
    y: 771.92,
    width: 97.16,
    height: 19.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 2317.11,
    y: 622.89,
    width: 117.16,
    height: 10.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 2420.87,
    y: 622.89,
    width: 13.41,
    height: 147.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 2314.96,
    y: 622.89,
    width: 11.29,
    height: 147.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 2356.34,
    y: 699.49,
    width: 36.31,
    height: 72.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 2387.41,
    y: 699.64,
    width: 5.24,
    height: 72.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 2356.34,
    y: 699.49,
    width: 36.31,
    height: 6.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 2356.34,
    y: 699.49,
    width: 6.45,
    height: 71.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 2469.32,
    y: 661.01,
    width: 70.89,
    height: 61.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "2474.07 722.31 2474.07 668.27 2533.42 668.27 2533.42 722.31 2539.19 722.31 2539.19 661.01 2468.3 661.01 2468.3 722.31 2474.07 722.31"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 2587.46,
    y: 661.01,
    width: 70.89,
    height: 61.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "2592.21 722.31 2592.21 668.27 2651.56 668.27 2651.56 722.31 2657.33 722.31 2657.33 661.01 2586.44 661.01 2586.44 722.31 2592.21 722.31"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 2587.46,
    y: 557.49,
    width: 70.89,
    height: 61.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "2592.21 618.79 2592.21 564.75 2651.56 564.75 2651.56 618.79 2657.33 618.79 2657.33 557.49 2586.44 557.49 2586.44 618.79 2592.21 618.79"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 2469.32,
    y: 557.49,
    width: 70.89,
    height: 61.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "2474.07 618.79 2474.07 564.75 2533.42 564.75 2533.42 618.79 2539.19 618.79 2539.19 557.49 2468.3 557.49 2468.3 618.79 2474.07 618.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2559,486.18c-11.86,1.94-21,13-21,26.42s9.11,24.48,21,26.42c11.86-1.94,21-13,21-26.42S2570.87,488.12,2559,486.18Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2545.8,532.08l34.39-37.29c-.4-.6-.82-1.19-1.25-1.76a33.24,33.24,0,0,1-3.8-4.2l-35.45,38.43C2541.63,529.06,2543.41,531.19,2545.8,532.08Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2582.9,512.93a34,34,0,0,1,0-8.19l-29.17,31.64h10.56l18.51-20.08A29.12,29.12,0,0,1,2582.9,512.93Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "2433.1 512.24 2562.4 429.3 2690.89 520.84 2690.89 508.42 2562.18 415.75 2433.1 499.48 2433.1 512.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2564.09,486.18a23.74,23.74,0,0,0-2.77.66c10.47,3.08,18.19,13.42,18.19,25.76s-7.72,22.68-18.19,25.77a23.7,23.7,0,0,0,2.77.65c11.87-1.94,21-13,21-26.42S2576,488.12,2564.09,486.18Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 2211.53,
    y: 660.86,
    width: 70.89,
    height: 61.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "2216.28 722.16 2216.28 668.12 2275.63 668.12 2275.63 722.16 2281.4 722.16 2281.4 660.86 2210.51 660.86 2210.51 722.16 2216.28 722.16"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 2211.53,
    y: 557.34,
    width: 70.89,
    height: 61.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "2216.28 618.64 2216.28 564.6 2275.63 564.6 2275.63 618.64 2281.4 618.64 2281.4 557.34 2210.51 557.34 2210.51 618.64 2216.28 618.64"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 2093.38,
    y: 557.34,
    width: 70.89,
    height: 61.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "2098.13 618.64 2098.13 564.6 2157.49 564.6 2157.49 618.64 2163.26 618.64 2163.26 557.34 2092.36 557.34 2092.36 618.64 2098.13 618.64"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 2093.38,
    y: 660.1,
    width: 70.89,
    height: 61.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "2098.13 721.4 2098.13 667.36 2157.49 667.36 2157.49 721.4 2163.26 721.4 2163.26 660.1 2092.36 660.1 2092.36 721.4 2098.13 721.4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 2183.75,
    cy: 494.9,
    rx: 20.97,
    ry: 26.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2170.93,534.73l32-36c-.37-.58-.76-1.15-1.16-1.7a32,32,0,0,1-3.55-4.05l-33,37.07C2167,531.81,2168.71,533.87,2170.93,534.73Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2205.48,516.26a34.26,34.26,0,0,1,.05-7.9l-27.17,30.51h9.82l17.25-19.37A29.12,29.12,0,0,1,2205.48,516.26Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2717.86,755.81a10.22,10.22,0,0,0,3.64,13.26l8.59-17.21A8.68,8.68,0,0,0,2717.86,755.81Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M158.13,767.43a10.21,10.21,0,0,0,3.64,13.25l8.59-17.2A8.68,8.68,0,0,0,158.13,767.43Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M235.67,755.87a8.61,8.61,0,0,0-12.48,2.84L238.3,769.4A10.28,10.28,0,0,0,235.67,755.87Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2783.53,763.4c-3.44-2.58-7.76-2.28-9.65.69l12.45,9.35C2788.22,770.48,2787,766,2783.53,763.4Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "2057.17 512.1 2186.47 429.15 2314.96 512 2314.96 499.58 2186.25 415.6 2057.17 499.33 2057.17 512.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2188.16,486a23.43,23.43,0,0,0-2.78.66c10.48,3.08,18.2,13.42,18.2,25.76s-7.72,22.68-18.2,25.77a23.4,23.4,0,0,0,2.78.65c11.86-1.94,21-13,21-26.42S2200,488,2188.16,486Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "2356.37 699.32 2356.37 707.28 2363.7 699.32 2356.37 699.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "2356.37 728.05 2382.86 699.32 2373.87 699.32 2356.37 718.3 2356.37 728.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "2356.37 759.85 2356.37 769.6 2392.06 730.89 2392.06 721.14 2356.37 759.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "2392.06 769.6 2392.06 762.7 2384.21 769.6 2392.06 769.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "2374.04 771.21 2392.06 751.67 2392.06 741.92 2365.05 771.21 2374.04 771.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "2356.37 739.08 2356.37 748.83 2392.06 710.12 2392.06 700.37 2356.37 739.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2710.08,693.51c0,26,19.46,47.12,43.45,47.12s43.45-21.1,43.45-47.12S2765.79,563,2753.53,563,2710.08,667.49,2710.08,693.51Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M84.08,692.74c0,26,19.45,47.12,43.45,47.12S171,718.76,171,692.74s-31.2-130.47-43.45-130.47S84.08,666.72,84.08,692.74Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M157,711.34c0,21.77,16.28,39.42,36.36,39.42s36.35-17.65,36.35-39.42-26.1-109.17-36.35-109.17S157,689.56,157,711.34Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 2170.67,
    y: 756.8,
    width: 25.63,
    height: 14.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 2194.52,
    y: 739.63,
    width: 25.63,
    height: 14.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 2431.88,
    y: 530.54,
    width: 25.63,
    height: 14.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 2664.17,
    y: 741.76,
    width: 25.63,
    height: 14.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 2574.65,
    y: 620.93,
    width: 25.63,
    height: 14.14
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "817.31 717.85 821.39 702.11 827.6 705.34 824.45 716.31 824.64 729.79 833.95 729.75 833.34 707.54 830.74 694.58 822.88 691.06 813.05 708.54 812.61 727.68 813.04 729.82 821.27 729.8 817.31 717.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "817.15 715.9 822.85 702.11 828.78 705.34 823.98 714.36 825.95 729.79 834.85 729.75 834.27 707.54 831.78 694.58 824.27 691.06 814.88 708.54 815.53 727.68 815.94 729.82 822.73 729.8 817.15 715.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M2,696.31c0,21.33,18.31,38.62,40.9,38.62s40.9-17.29,40.9-38.62S54.47,589.36,42.94,589.36,2,675,2,696.31Z",
    transform: "translate(0.68 -17.55)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "2808.41 796.65 2042.78 792.27 2042.78 788.39 2808.41 792.77 2808.41 796.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "575.94 778.03 448.34 778.03 448.34 572.71 575.94 572.35 575.94 577.14 572.36 577.14 572.36 576.24 451.92 576.58 451.92 774.14 572.36 774.14 572.36 603.32 575.94 603.32 575.94 778.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M451.25,795.58H250.61V590.26l200.64-.36ZM254.19,791.7H447.66V593.79l-193.47.35Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M390.27,747.81H306.75V639h83.52Zm-79.93-3.88h76.35V642.85H310.34Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M550.51,718.17H473V653.45h77.49Zm-73.91-3.88h70.32V657.34H476.6Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M577.57,593.79H468.3V582.7l-80.53-74.11,42.61-38.48h161.2l58.85,58.28Zm-105.68-3.88H576.28L645,528.25,590.19,474H431.68l-38.34,34.63,78.55,72.28Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M776.49,795.58H571.68V619.19H776.49ZM575.26,791.7H772.9V623.07H575.26Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M795.87,623.07H553.46V610.39l.65-.59L674.66,501.6,795.87,610.39ZM557,619.19H792.28v-7L674.66,506.64,557,612.21Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M471.89,593.79H229.69V580.72l121.2-111.15,121,111.33Zm-238.62-3.88h235V582.7l-117.41-108L233.27,582.52Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M710.26,795.53H639.05V706.65h71.21Zm-67.63-3.88h64V710.54h-64Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M700.57,795.58H648.86V717.3h51.71Zm-48.13-3.88H697V721.18H652.44Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M731.87,795.53H721.13V697.41h10.74Zm-7.16-3.88h3.58V701.29h-3.58Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M627.56,795.53H616.82V697.41h10.74Zm-7.16-3.88H624V701.29H620.4Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M738.91,701.29H610.29v-12l21.89-25.18,85,0,21.76,25.24Zm-125-3.88H735.33V691l-19.74-22.89-81.86,0-19.86,22.85Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M449.45,808.65H231.52v-16H449.45ZM235.07,805H445.89v-8.68H235.07Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "575.35 791.01 571.77 791.01 571.77 775.99 789.08 775.99 789.08 779.87 575.35 779.87 575.35 791.01"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 448.34,
    y: 776.07,
    width: 3.58,
    height: 13.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 332.79,
    y: 623.35,
    width: 3.58,
    height: 105.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 360.75,
    y: 623.35,
    width: 3.58,
    height: 105.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 309.22,
    y: 656.56,
    width: 79.93,
    height: 3.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 510.17,
    y: 637.91,
    width: 3.58,
    height: 60.26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 511.96,
    y: 662.26,
    width: 37.44,
    height: 3.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 232.16,
    y: 562.13,
    width: 356.26,
    height: 3.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 555.93,
    y: 591.8,
    width: 238.82,
    height: 3.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 612.76,
    y: 670.59,
    width: 125.04,
    height: 3.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 2586.66,
    y: 579.85,
    width: 71.05,
    height: 3.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 2631.85,
    y: 558.28,
    width: 3.58,
    height: 61.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 2608.77,
    y: 558.28,
    width: 3.58,
    height: 61.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 2586.66,
    y: 683.86,
    width: 71.05,
    height: 3.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 2631.85,
    y: 662.29,
    width: 3.58,
    height: 61.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 2608.77,
    y: 662.29,
    width: 3.58,
    height: 61.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 2468.36,
    y: 683.86,
    width: 71.05,
    height: 3.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 2513.56,
    y: 662.29,
    width: 3.58,
    height: 61.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 2490.48,
    y: 662.29,
    width: 3.58,
    height: 61.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 2468.36,
    y: 580.09,
    width: 71.05,
    height: 3.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 2513.56,
    y: 558.53,
    width: 3.58,
    height: 61.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 2490.48,
    y: 558.53,
    width: 3.58,
    height: 61.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2690.91,792.6H2429.54V517.69l131.13-85.43.94.67,129.3,92Zm-257.79-3.88h254.21V527l-126.74-90.18-127.47,83Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2707.81,541.6,2560.59,436.85l-147.93,96.37-8.09-11.9,155.88-102.61,155.22,111.22ZM2560.67,432.26l.94.67,145.32,103.39,3.63-5.39L2560.37,423.3l-150.59,99.14,3.83,5.63Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2540.37,742.85h-74.48V677.66h74.48Zm-70.9-3.89h67.32V681.54h-67.32Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2658.51,743.33H2584V678.14h74.47Zm-70.89-3.89h67.31V682h-67.31Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2540.37,639.32h-74.48V574.14h74.48Zm-70.9-3.88h67.32V578h-67.32Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2658.51,639.81H2584V574.62h74.47Zm-70.89-3.89h67.31V578.51h-67.31Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2700.38,812H2419.86V788.72h280.52Zm-276.94-3.89H2696.8V792.6H2423.44Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2560.36,542.33c-14.59,0-26.46-12.87-26.46-28.69s11.87-28.7,26.46-28.7,26.46,12.88,26.46,28.7S2575,542.33,2560.36,542.33Zm0-53.5c-12.61,0-22.88,11.13-22.88,24.81s10.27,24.81,22.88,24.81,22.88-11.13,22.88-24.81S2573,488.83,2560.36,488.83Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 2210.72,
    y: 579.7,
    width: 71.05,
    height: 3.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 2255.92,
    y: 558.14,
    width: 3.58,
    height: 61.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 2232.84,
    y: 558.14,
    width: 3.58,
    height: 61.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 2210.72,
    y: 683.71,
    width: 71.05,
    height: 3.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 2255.92,
    y: 662.14,
    width: 3.58,
    height: 61.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 2232.84,
    y: 662.14,
    width: 3.58,
    height: 61.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 2092.43,
    y: 579.94,
    width: 71.05,
    height: 3.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 2137.62,
    y: 558.38,
    width: 3.58,
    height: 61.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 2114.54,
    y: 558.38,
    width: 3.58,
    height: 61.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2423.44,812H2320.87v-23.3h102.57Zm-99-3.89h95.41V792.6h-95.41Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2433.12,792.46H2311.76V639.54h121.36Zm-117.78-3.89h114.2V643.43h-114.2Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2433.12,643.43H2311.4V624.49h121.72ZM2315,639.54h114.56V628.37H2315Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2406.19,792.27h-66.84V701.49h66.84Zm-63.25-3.89h59.67v-83h-59.67Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2392.81,792.46h-39.89V716.13h39.89Zm-36.31-3.89h32.72V720H2356.5Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "2315.66 774.9 2111.54 774.9 2111.54 771.02 2312.08 771.02 2312.08 502.09 2185.37 419.12 2057.87 502.19 2057.87 771.02 2088.88 771.02 2088.88 774.9 2054.28 774.9 2054.28 499.99 2185.38 414.58 2315.66 499.9 2315.66 774.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2331.91,533.08l-147.22-96.41-148,96.4-8.1-11.9,155.85-102.59.93.62,154.36,102.21Zm-298.07-10.79,3.84,5.63,147-95.79L2331,527.91l3.63-5.39-150.11-99.39Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2282.58,743.18H2208.1V678h74.48Zm-70.9-3.89H2279V681.88h-67.31Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2164.43,639.17H2090V574h74.47Zm-70.89-3.88h67.31V577.87h-67.31Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 2092.43,
    y: 682.7,
    width: 71.05,
    height: 3.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 2137.62,
    y: 661.14,
    width: 3.58,
    height: 61.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 2114.54,
    y: 661.14,
    width: 3.58,
    height: 61.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2164.43,741.94H2090V676.75h74.47Zm-70.89-3.89h67.31V680.63h-67.31Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2282.58,639.66H2208.1V574.47h74.48Zm-70.9-3.89H2279V578.36h-67.31Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "2325.13 792.52 2321.55 792.52 2321.55 774.9 2046.36 774.9 2046.36 792.52 2042.78 792.52 2042.78 771.02 2325.13 771.02 2325.13 792.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2184.43,542.18c-14.6,0-26.47-12.87-26.47-28.69s11.87-28.7,26.47-28.7,26.46,12.88,26.46,28.7S2199,542.18,2184.43,542.18Zm0-53.5c-12.62,0-22.88,11.13-22.88,24.81s10.26,24.81,22.88,24.81,22.87-11.13,22.87-24.81S2197,488.68,2184.43,488.68Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 2752.42,
    y: 665.74,
    width: 3.58,
    height: 128.72
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "2755.81 719.78 2752.61 718.04 2766.29 688.54 2769.49 690.29 2755.81 719.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M2753.53,742.57c-24.94,0-45.24-22-45.24-49.06,0-14,8.67-48.68,17.23-75.63,8.23-25.9,19.77-56.78,28-56.78s19.78,30.88,28,56.78c8.56,27,17.23,61.58,17.23,75.63C2798.77,720.56,2778.48,742.57,2753.53,742.57Zm0-177.59c-3,0-12,14.43-24.62,54.17-9.87,31.06-17,62.33-17,74.36,0,24.91,18.68,45.18,41.65,45.18s41.66-20.27,41.66-45.18c0-12-7.16-43.3-17-74.36C2765.53,579.41,2756.51,565,2753.53,565Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 126.42,
    y: 660.44,
    width: 3.58,
    height: 127.61
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "129.81 719.01 126.61 717.26 140.29 687.77 143.49 689.52 129.81 719.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M127.53,741.8c-25,0-45.24-22-45.24-49.06,0-14,8.67-48.68,17.23-75.63,8.23-25.9,19.77-56.78,28-56.78s19.78,30.88,28,56.78c8.56,26.95,17.23,61.58,17.23,75.63C172.77,719.79,152.47,741.8,127.53,741.8Zm0-177.59c-3,0-12,14.43-24.63,54.17-9.86,31.06-17,62.33-17,74.36,0,24.91,18.69,45.18,41.66,45.18s41.66-20.27,41.66-45.18c0-12-7.17-43.3-17-74.36C139.53,578.64,130.51,564.21,127.53,564.21Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 190.69,
    y: 681.91,
    width: 3.58,
    height: 106.48
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "195.68 730.59 192.48 728.85 203.92 704.17 207.12 705.91 195.68 730.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M193.4,752.7c-15.94,0-30.33-10.9-35.82-27.11l3.36-1.34c5,14.69,18,24.57,32.46,24.57,19.06,0,34.56-16.82,34.56-37.48,0-10-6-36.16-14.23-62.12-10.45-32.87-18-45.11-20.33-45.11-3.3,0-13.84,21.17-25.07,60.93l-3.43-1.14a418.64,418.64,0,0,1,14.33-42.68c7.65-18.61,11.59-21,14.17-21,7.06,0,16.79,26,23.71,47.73s14.43,51,14.43,63.39C231.54,734.14,214.43,752.7,193.4,752.7Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M807.8,805.61l-2.95-2.19L822.13,776h0s1.34-2.26,2.93-5.39l3.14,1.87c-1.66,3.27-3,5.57-3.09,5.67Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M807.43,810l-6.21-8.23,13.19-29.18c-1-5.27-.81-14.54-.8-14.95l3.58.09c0,.1-.2,10,.85,14.64l.15.69-12.74,28.18,4.76,6.3Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "838.53 789.72 837.09 755.31 832.02 730.27 835.52 729.44 840.66 754.97 842.1 789.54 838.53 789.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M844.39,810.22H834.11l-5.17-34.05L816.58,764a16.25,16.25,0,0,1-2.91-6,17.24,17.24,0,0,1-.16-7.63l.65-3,3.49.9-.65,3a13.05,13.05,0,0,0,.13,5.73,12.42,12.42,0,0,0,2.12,4.46l13,12.82,4.87,32.14h7.24Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M810.94,748.19l-.17-1.74c-2-20.74,9.16-37.11,10.16-38.53l2.88-4.91,3,2.09-3,5.13c-.11.15-10.73,15.23-9.61,34.07l5.85,0v3.88Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M830.41,708.69c-2.24,0-4.76-1.4-6.86-3.88a2.07,2.07,0,0,1-.75-2.67,1.75,1.75,0,0,1,2.65-.66v0h0a2.26,2.26,0,0,1,.62.52c1.6,2,3.71,3.13,4.89,2.66.8-.31,1.54-1.54,1.93-3.22a11.14,11.14,0,0,0-.19-5.75,13.13,13.13,0,0,0-.8-1.68l3.07-2a17.65,17.65,0,0,1,1.1,2.37,15.16,15.16,0,0,1,.29,8c-.69,3-2.22,5.16-4.19,5.93A4.8,4.8,0,0,1,830.41,708.69Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "823.26 742.19 821.93 738.59 825.31 737.12 822.56 717.41 826.33 704.25 829.75 705.4 826.23 717.71 829.27 739.59 823.26 742.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "822.67 740.57 816.39 717.57 820.46 702 823.91 703.06 820.12 717.55 826.11 739.47 822.67 740.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M823.17,704.62l-.36-.3a11.5,11.5,0,0,1-2.18-14.08l.08-.14a8.42,8.42,0,0,1,7.94-4.1,8.64,8.64,0,0,1,7.35,5.72l.78,1.91-7.92,3.08-1.21-3.65,4-1.56a4.81,4.81,0,0,0-3.25-1.63,5,5,0,0,0-4.66,2.31l-1.58-.91,1.51,1a7.37,7.37,0,0,0,1.38,9l.3.24Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "825.54 730.6 825.52 726.72 832.3 726.68 831.75 708.2 829.15 695.17 828.68 689.31 832.25 688.97 832.71 694.71 835.33 707.9 836 730.55 825.54 730.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M42.94,737.92c-21.43,0-38.87-18.85-38.87-42,0-12,7.45-41.69,14.8-64.77,7.07-22.18,17-48.63,24.07-48.63S59.93,609,67,631.14c7.35,23.08,14.8,52.73,14.8,64.77C81.8,719.07,64.36,737.92,42.94,737.92Zm0-152.08c-2.56,0-10.31,12.35-21.16,46.39-8.47,26.59-14.63,53.38-14.63,63.68,0,21.33,16,38.68,35.79,38.68s35.78-17.35,35.78-38.68c0-10.3-6.15-37.09-14.63-63.68C53.24,598.19,45.5,585.84,42.94,585.84Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 41.83,
    y: 717.83,
    width: 3.58,
    height: 68.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M573.11,808.65h-124V793.46h124Zm-122-2.53h120v-8.23h-120Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M795.87,808.65H571.68V793.46H795.87Zm-220.54-2.53H792.21v-8.23H575.33Z",
    transform: "translate(0.68 -17.55)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 233.99,
    y1: 784.17,
    x2: 0.68,
    y2: 784.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 233.31,
    y1: 789.39,
    y2: 789.39
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanding);
export default __webpack_public_path__ + "static/media/landing.9efd94b8c06a714f683614790a609036.svg";
export { ForwardRef as ReactComponent };